import {registerCrudStore} from '@/libs/core/+state/register-crud-store';
import {VisitRuleModel} from '@/libs/Api';
import {VisitRulesDataService} from '@/libs/visit-rules/visit-rules-data-service';
import {BusinessModule} from '@/libs/core/models/business-module';

export const visitRulesStore = registerCrudStore<VisitRuleModel, VisitRuleModel>(BusinessModule.VisitRule, new VisitRulesDataService());
